import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { UnitsDataRepository } from './units-repo';
import { UnitsDataDto } from './units.dto';
import { UnitsDataAdapter } from './units-adapter';
import { CommonResponseModel } from '@project-management-system/shared-models';
import { UnitsData } from './units.entity';
import { Repository } from 'typeorm';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';

@Injectable()
export class UnitsDataService {
    constructor(
        @InjectRepository(UnitsData)
        private unitsDataRepository: Repository<UnitsData>,
        private unitsDataAdapter: UnitsDataAdapter
    ) { }

    // async createUnitsData(dto: UnitsDataDto): Promise<CommonResponseModel> {
    //     try {
    //         const unitsDataaa = this.unitsDataAdapter.convertDtoToEntity(dto);
    //         await this.unitsDataRepository.save(unitsDataaa);
    //         return new CommonResponseModel(true, 980, 'units created successfully')
    //     } catch (error) {
    //         console.error('Error while creating units', error);
    //         throw error
    //     }
    // }

    async createUnitsData(req: UnitsDataDto): Promise<CommonResponseModel> {
        try {
            const check = await this.unitsDataRepository.find({ where: { unitName: req.unitName } });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'Unit Name already exists');
            }
            const entity = new UnitsData();
            entity.unitName = req.unitName;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;

            const save = await this.unitsDataRepository.save(entity);

            if (!save) {
                return new CommonResponseModel(false, 0, 'Something went wrong in Unit Data creation', []);
            } else {
                return new CommonResponseModel(true, 1, 'Created successfully', save);
            }

        } catch (err) {
            throw err;
        }
    }

    async getAllUnitsData(): Promise<CommonResponseModel> {
        const data = await this.unitsDataRepository.find();
        if (data) {
            return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
            return new CommonResponseModel(false, 0, "Data Retrived");
        }
    }

    async updateUnitsData(req: UnitsDataDto): Promise<CommonResponseModel> {
        try {
            const check = await this.unitsDataRepository.find({ where: { unitName: req.unitName } });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'Name already exists');
            }
            
            let updateResult;
            updateResult = await this.unitsDataRepository.update(
                { unitId: req.unitId },
                {
                    unitName: req.unitName,
                }
            );

            if (updateResult.affected > 0) {
                return new CommonResponseModel(true, 11, 'Updated successfully', updateResult);
            } else {
                return new CommonResponseModel(false, 11, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async activateOrDeactivateUnitdata(req: UnitsDataDto): Promise<CommonResponseModel> {
        try {
            const Exists = await this.unitsDataRepository.findOne({ where: { unitId: req.unitId } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Data information.Refresh and try again');
                } else {

                    const update = await this.unitsDataRepository.update(
                        { unitId: req.unitId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Unit data is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Job Work is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Unit data is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Unit data is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

}
